import { ID_BRASIL, ID_FRANCE, ID_PORTUGAL } from '~/utils/constants/idsCountries.js'

const GEO_HEADER_NAMES = ['cloudfront-viewer-country', 'x-amzn-cf-country', 'x-geo-country'] as const

const COUNTRY_TO_COUNTRY_ID: Record<string, number> = {
	BR: ID_BRASIL,
	FR: ID_FRANCE,
	PT: ID_PORTUGAL,
}

const readGeoCountryCode = () => {
	if (import.meta.server) {
		const headers = useRequestHeaders([...GEO_HEADER_NAMES])

		for (const name of GEO_HEADER_NAMES) {
			const value = headers[name]
			if (typeof value === 'string' && value.trim()) {
				return value.trim().toUpperCase()
			}
		}
	}

	return null
}

/**
 * Returns a shared Nuxt state holding the ISO 3166-1 alpha-2 country code detected from
 * CloudFront geo-headers on the server. The value is `null` when undetectable.
 */
export const useGeoCountryCode = () => {
	return useState<string | null>('geo-country-code', readGeoCountryCode)
}

/**
 * Converts a geo country code to the app's internal numeric country ID.
 * Returns `null` for unmapped or absent codes.
 * @param countryCode - ISO 3166-1 alpha-2 code, e.g. `'BR'`, `'FR'`, `'PT'`.
 */
export const geoCountryCodeToCountryId = (countryCode: string | null | undefined) => {
	if (!countryCode) return null
	return COUNTRY_TO_COUNTRY_ID[countryCode.toUpperCase()] ?? null
}
